import { useStore } from "..";
export const useBilling = () => useStore(({ billing }) => billing);
